<ng-container *ngIf="!isLoading">
  <div class="{{ configService?.project }}__main__layout__router">
    <router-outlet></router-outlet>
  </div>
  <ng-container *ngTemplateOutlet="isResponsive ? navbar : footer"></ng-container>
</ng-container>

<ng-template #navbar>
  <app-navbar *ngIf="showNavbar"></app-navbar>
</ng-template>
<ng-template #footer>
  <app-footer></app-footer>
</ng-template>
<!-- TODO:: LOADER -->
